// extracted by mini-css-extract-plugin
module.exports = {"status":"card-watch-status_status__TMgDV","gray":"card-watch-status_gray__lJBPT","green":"card-watch-status_green__RcNbB"};